import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { EmptyStateGetAccessCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/get-access';
import { EmptyInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-info-box';
import { EmptyStateExampleFundProfilesCTA } from '../../../../impact-lens-profile/common/components/empty-states/ctas/empty-state-example-fund-profiles-cta';

export function NoDrillDownAccess() {
  return (
    <EmptyInfoBox title="Subscribe to access full data" topColor={BouColor.IMPACT_NEGATIVE_PURPLE}>
      <>
        <EmptyStateGetAccessCTA />
        <EmptyStateExampleFundProfilesCTA
          lensTypeToLinkTo={ImpactLensType.UPRIGHT_NET_IMPACT}
          profileListText="To see what the full data looks like, please see the example listed and unlisted fund profiles:"
        />
      </>
    </EmptyInfoBox>
  );
}
